export function consumeAiCommand({
  command,
  handledCommand,
  onPrepare,
  onSubmit,
  onHandled,
}) {
  const commandId = command?.id;
  const instruction = String(command?.instruction || "").trim();
  if (
    !commandId
    || !instruction
    || handledCommand?.current === commandId
  ) return false;

  handledCommand.current = commandId;
  onPrepare?.(instruction);
  if (command.autoSubmit !== false) onSubmit?.(instruction);
  onHandled?.(commandId);
  return true;
}

export function chatPromptForAiEdit({ instruction, result } = {}) {
  return String(
    instruction || result?.chatPrompt || result?.text || "",
  ).trim();
}
